export { default } from "./DeliveryHead";
